import React from "react";
import Logo from "../assets/images/logo.png";

const Version = props => {
  return <img className="mb-4" src={Logo} alt="" width="72" height="72" />;
};

export default Version;
